import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import VideoCard from './VideoCard';
import CtaBanners from './CtaBanners';

const MainContent = ({ videos }) => {
  return (
    <ContentWrapper>
      <ContentContainer>
        <SubHeading>Product guides</SubHeading>
        <CardsSection>
          {videos.map((video, index) => (
            <VideoCard key={index} video={video} index={index} />
          ))}
        </CardsSection>
      </ContentContainer>
      <CtaBanners />
    </ContentWrapper>
  );
};

MainContent.propTypes = {
  videos: PropTypes.array.isRequired,
};

export default MainContent;

const ContentWrapper = styled.div`
  background: #fff;
  border-radius: 24px 24px 0 0;
  display: flex;
  padding: 40px 180px 40px 180px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  @media screen and (max-width: 768px) {
    padding: 40px 20px;
    gap: 40px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
`;

const SubHeading = styled.h2`
  color: #000;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;

const CardsSection = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;
`;
